module.exports = __webpack_public_path__ + "static/media/event_rose.527f52b5.png";